import React from "react";
import { useHistory } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Navbar from "../../general/Navbar.js";
import { Row, Col } from "react-bootstrap";

const LandingSegment = (props) => {
  const history = useHistory();
  return (
    <>
      <div className="landing-segment">
        <Navbar />
        <div className="landingTextBox">
          <h1 className="landing-text">
            Matamando Kalilani is a Full Stack <br /> <span>Cloud</span> &{" "}
            <span> Web </span>
            Developer.
          </h1>
        </div>

        <div className="cards">
          <Row style={{ margin: "0px" }}>
            <Col
              className=""
              style={{ padding: "0px" }}
              sm={12}
              md={6}
              lg={6}
              xl={4}
            >
              {/* <div className="card card-one">
                <div className="card-content">
                  <p className="card-content-header">Mobile Development</p>
                  <p className="card-content-body">
                    I build mobile applications for the Android & IOS platforms,
                    using the powerful Android Studio and Flutter frameworks.{" "}
                  </p>
                  <div className="card-button-group">
                    <Button
                      route="/contact-me"
                      label="Start Project"
                      color="#FFFFFFD1"
                      textColor="black"
                    />
                    <Button
                      route="/projects/mobile-development#top"
                      label="See My Work"
                      className={true}
                      fontWeight="400"
                      textColor="white"
                    />
                  </div>
                </div>
              </div> */}
            </Col>
            <Col style={{ padding: "0px" }} sm={12} md={6} lg={6} xl={4}>
              <div className="card card-two">
                <div className="card-content">
                  <p className="card-content-header">Web Development</p>
                  <p className="card-content-body">
                    I build full stack websites & web applications using
                    NodeJS, ReactJS and NextJS, all while leveraging the
                    power of various NoSQL and SQL databases.
                  </p>
                  <div className="card-button-group">
                    <Button
                      route="/contact-me"
                      label="Start Project"
                      color="#FFFFFFD1"
                      textColor="black"
                    />
                    <Button
                      route="/projects/web-development#top"
                      label="See My Work"
                      className={true}
                      fontWeight="400"
                      textColor="white"
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col
              className=""
              style={{ padding: "0px" }}
              sm={12}
              md={6}
              lg={6}
              xl={4}
            >
              <div className="card card-three">
                <div className="card-content">
                  <p className="card-content-header">Software Development</p>
                  <p className="card-content-body">
                    I use the principles of software engineering to design,
                    develop, and deploy computer software.
                  </p>
                  <div className="card-button-group">
                    <Button
                      route="/contact-me"
                      label="Start Project"
                      color="#FFFFFFD1"
                      textColor="black"
                    />
                    <Button
                      route="/projects/software-development#top"
                      label="See My Work"
                      className={true}
                      fontWeight="400"
                      textColor="white"
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default LandingSegment;

function Button(props) {
  var className = props.className ? "button invert-button" : "button";
  return (
    <HashLink
      style={{ textDecoration: "none", color: props.textColor }}
      smooth
      to={props.route}
    >
      <div
        className={className}
        style={{
          backgroundColor: props.color,
          color: props.textColor,
        }}
      >
        {" "}
        <p style={{ fontWeight: props.fontWeight }}>{props.label}</p>
      </div>
    </HashLink>
  );
}
